import {
  REQUEST_CREATE_ADDITIONAL_WARRENTIES_REGULATION,
  REQUEST_CREATE_CORPOREAL_REGULATION,
  REQUEST_CREATE_CORPO_ENCRYPTED_DOCUMENT,
  REQUEST_CREATE_MATERIAL_REGULATION,
  REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VEHICLES,
  REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VICTIMS,
  REQUEST_SAGIS_CLAIM_INFO,
  SET_CORPOREAL_ENCRYPTED_DOCUMENTS,
  SET_JUDGEMENT_ON_MERITS_BY_VEHICLES,
  SET_JUDGEMENT_ON_MERITS_BY_VICTIMS,
  SET_SAGIS_CLAIM,
  REQUEST_MATERIAL_ENCRYPTED_DOCUMENT,
  SET_MATERIAL_ENCRYPTED_DOCUMENTS,
  REQUEST_GET_ASSIGNED_LAWYERS,
  SET_ASSIGNED_LAWYERS,
  SET_REGULATIONS,
  REQUEST_GET_REGULATIONS,
  RESET_SAGIS_CLAIM_INFO,
  REQUEST_CREATE_SUMMARY_SHEET_REGULATION,
  SET_CREATED_REGULATIONS,
  UPLOAD_DOCUMENT_REGULATION,
  REQUEST_GET_REGULATION,
  SET_REGULATION,
  REQUEST_VALIDATE_PROVISION,
  REQUEST_VALIDATE_REGULATION,
} from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { get } from 'lodash';

export const requestSagisClaimInfo = (
  claimNumber: string,
  successCallback: Function,
) => ({
  type: REQUEST_SAGIS_CLAIM_INFO,
  claimNumber,
  successCallback,
});

export const setSagisClaim = (sagisClaim: any) => ({
  type: SET_SAGIS_CLAIM,
  sagisClaim,
});
export const requestGetJudgementOnMeritsByVictims = (
  claimId: number,
  victims: number[],
  beneficiaries: number[],
  procedureNatureId: number,
) => ({
  type: REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VICTIMS,
  claimId,
  victims,
  beneficiaries,
  procedureNatureId,
});
export const requestGetJudgementOnMeritsByVehicles = (
  claimId: number,
  vehicles: number[],
  procedureNatureId: number,
  courtNumber: string | null,
) => ({
  type: REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VEHICLES,
  claimId,
  vehicles,
  courtNumber,
  procedureNatureId,
});

export const setJudgementOnMeritsByVictims = (
  judgementOnMeritsByVictims: any,
) => ({
  type: SET_JUDGEMENT_ON_MERITS_BY_VICTIMS,
  judgementOnMeritsByVictims,
});

export const setJudgementOnMeritsByVehicles = (
  judgementOnMeritsByVehicles: any,
) => ({
  type: SET_JUDGEMENT_ON_MERITS_BY_VEHICLES,
  judgementOnMeritsByVehicles,
});
export const setEncryptedDocuments = (corporealEncryptedDocuments: any) => {
  return {
    type: SET_CORPOREAL_ENCRYPTED_DOCUMENTS,
    corporealEncryptedDocuments: get(corporealEncryptedDocuments, 'data', []),
  };
};
export const setMaterialEncryptedDocuments = (
  materialEncryptedDocuments: any,
) => {
  return {
    type: SET_MATERIAL_ENCRYPTED_DOCUMENTS,
    materialEncryptedDocuments: get(materialEncryptedDocuments, 'data', []),
  };
};
export const requestCreateCorpoEncryptedDocument = (
  corporealEncryptedDocuments: any,
  successCallback: Function,
) => ({
  type: REQUEST_CREATE_CORPO_ENCRYPTED_DOCUMENT,
  corporealEncryptedDocuments,
  successCallback,
});

export const requestMaterialEncryptedDocument = (
  materialEncryptedDocuments: any,
  successCallback: Function,
) => ({
  type: REQUEST_MATERIAL_ENCRYPTED_DOCUMENT,
  materialEncryptedDocuments,
  successCallback,
});

export const requestCreateCorporealRegulation = (
  corporealRegulation: any,
  successCallback: Function,
  failCallBack: Function,
) => {
  return {
    type: REQUEST_CREATE_CORPOREAL_REGULATION,
    corporealRegulation,
    successCallback,
    failCallBack,
  };
};
export const requestCreateSummarySheetRegulation = (
  summarySheet: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_CREATE_SUMMARY_SHEET_REGULATION,
    summarySheet,
    successCallback,
  };
};
export const requestCreateMaterialRegulation = (
  claimNumber: string,
  materialRegulation: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_CREATE_MATERIAL_REGULATION,
    claimNumber,
    materialRegulation,
    successCallback,
  };
};
export const requestCreateAdditionalWarrentiesRegulation = (
  claimNumber: string,
  materialRegulation: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_CREATE_ADDITIONAL_WARRENTIES_REGULATION,
    claimNumber,
    materialRegulation,
    successCallback,
  };
};
export const requestGetAssignedLawyers = (lawyers: any) => ({
  type: REQUEST_GET_ASSIGNED_LAWYERS,
  lawyers,
});
export const setAssignedLawyers = (assignedLawyers: any) => ({
  type: SET_ASSIGNED_LAWYERS,
  assignedLawyers: get(assignedLawyers, 'data', []),
});
export const setRegulations = (regulations: any) => {
  return {
    type: SET_REGULATIONS,
    regulations,
  };
};
export const setCreatedRegulations = (createdRegulations: any) => {
  return {
    type: SET_CREATED_REGULATIONS,
    createdRegulations: get(createdRegulations, 'data', []),
  };
};
export const requestGetRegulations = (claimId: number) => ({
  type: REQUEST_GET_REGULATIONS,
  claimId,
});

export const resetSagisInfoClaim = () => {
  return { type: RESET_SAGIS_CLAIM_INFO };
};
export const uploadDocumentRegulation = (uploadFile: any) => ({
  type: UPLOAD_DOCUMENT_REGULATION,
  uploadFile,
});

export const requestGetRegulation = (
  paymentId: number,
  isTransaction?: boolean,
) => ({
  type: REQUEST_GET_REGULATION,
  paymentId,
  isTransaction,
});

export const setRegulation = (regulation: any) => {
  return {
    type: SET_REGULATION,
    regulation,
  };
};
export const requestValidateProvision = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_VALIDATE_PROVISION,
    payload,
    successCallback,
  };
};

export const requestValidateRegulation = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_VALIDATE_REGULATION,
    payload,
    successCallback,
  };
};
